import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom"; // Removed unused useParams import
import "./App.css";
import Navbar from "./components/navbar";
import Footer from "./components/footer";
import Home from "./pages/Home";
import Faq from "./pages/Faq";
import About from "./pages/About";
import Contact from "./pages/Contact";
// import Gallery from "./components/Gallery";
import Activities from "./pages/Activities"; // Your Activities page
import Events from "./pages/Events"; // Your Events page
import Infrastructure from "./pages/Infrastructure"; // Your Infrastructure page

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

// ScrollToTop component to scroll to the top on route change
function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top on route change
  }, [location]);

  return null;
}

function App() {
  return (
    <div className="App">
      <Router>
        <ScrollToTop />
        <Navbar />

        {/* Dynamic Route for Gallery Pages */}
        <Routes>
          {/* <Route path="/gallery/:category" element={<GalleryWithData />} /> */}

          {/* Other Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/activities" element={<Activities />} />
          <Route path="/events" element={<Events />} />
          <Route path="/infrastructure" element={<Infrastructure />} />
        </Routes>

        <Footer />
      </Router>
    </div>
  );
}

// Wrapper component for gallery to handle dynamic content
// const GalleryWithData = () => {
//   const { category } = useParams();
//   const galleryInfo = galleryData[category]; // Fetch the category data dynamically

//   if (!galleryInfo) {
//     return <div>Gallery not found</div>; // Optional: show a message if gallery data is not found
//   }

//   return (
//     <Gallery
//       title={galleryInfo.title}
//       description={galleryInfo.description}
//       images={galleryInfo.images}
//     />
//   );
// };

export default App;
